import { Navbar } from 'react-bootstrap';
import logo from 'assets/img/logos/norscom.svg';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarToggleButton from './NavbarToggleButton';
import { Link } from 'react-router-dom';

const NavbarBrand = () => {
  const { breakpoints } = useBreakpoints();

  return (
    <>
      <div className="navbar-logo">
        {breakpoints.down('lg') && <NavbarToggleButton />}
        <Navbar.Brand as={Link} to="/">
          <div className="d-flex align-items-end">
            <img src={logo} alt={import.meta.env.VITE_COMPANY_NAME} height={30} />
            <p className="logo-text ms-2 d-sm-block d-none fs-8" style={{ marginBottom: '-4px' }}>
              {import.meta.env.VITE_NAME}
            </p>
          </div>
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
